export enum ProductionTechnology {
  Solar = 'solar',
  WindOnshore = 'wind_onshore',
}

export function mapProductionTechnology(productionTechnology: ProductionTechnology | null): 'solar' | 'wind' {
  switch (productionTechnology) {
    case ProductionTechnology.Solar:
      return 'solar'
    case ProductionTechnology.WindOnshore:
      return 'wind'
    default:
      throw new Error(`Unsupported productionTechnology ${productionTechnology}`)
  }
}
